import { TreatmentPlanDto } from "@core/models/http/treatment/treatment-plans/treatment-plan-dto";
import { IMaxxOptimizerQueryDto } from "../../../../core/models/http/treatment/treatment-plans/optimizer-dto";

export const mapTreatmentPlanOptimization = (
  tp: TreatmentPlanDto
): IMaxxOptimizerQueryDto => {
  return {
    TreatmentPlanId: tp.TreatmentPlanId,
    TreatmentPlan: tp,
    AdditionalCosts: tp.TreatmentOptimizer?.AdditionalCosts || [],
    ImaxxEvaluationResult: tp.TreatmentOptimizer?.ImaxxEvaluationResult,
  };
};
